import AccountSetupModal from "../../components/account/AccountSetupModal";

const SetupAccount = () => {
  return <AccountSetupModal />;
};

export default SetupAccount;
